import { useState } from "react";
import BaseClient from "../helper/Baseclient";
import { APIEndpoints } from "../constants/APIEndpoints";

const useMessages = () => {
  const [messageLoading, setMessageLoading] = useState(false);

  const getMessages = async (payload, { onSuccess, onFailed, headers }) => {
    try {
      setMessageLoading(true);
      await BaseClient.post(APIEndpoints.getData, payload, {
        onSuccess: onSuccess,
        onFailed: onFailed,
        headers: headers,
      });
    } finally {
      setMessageLoading(false);
    }
  };

  const sendNewMessage = async (payload, { onSuccess, onFailed, headers }) => {
    try {
      setMessageLoading(true);
      await BaseClient.post(APIEndpoints.sendNewMessage, payload, {
        onSuccess: onSuccess,
        onFailed: onFailed,
        headers: headers,
      });
    } finally {
      setMessageLoading(false);
    }
  };

  return {
    sendNewMessage,
    getMessages,
    messageLoading,
  };
};

export default useMessages;
